export default __webpack_public_path__ + "static/media/prevInactive.8f5a72e5.svg";